import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { useApi } from '../api-context';
import { queryKeys } from '../query-keys';
import { dashboardSchema, type Dashboard } from '../schemas';
import { useToken } from './use-token';

/** Alertes à corriger et chiffres d'activité du cabinet sur `days` jours (7, 30 ou 90). */
export function useDashboard(days: number) {
  const api = useApi();
  const token = useToken();

  return useQuery({
    queryKey: queryKeys.dashboard.detail(days),
    queryFn: () => api.get<Dashboard>(`/dashboard?days=${days}`, { schema: dashboardSchema }),
    enabled: token !== null,
    // Changer de période garde l'écran en place au lieu de le vider.
    placeholderData: keepPreviousData,
    // Une alerte corrigée doit disparaître sans recharger la page.
    refetchInterval: 60_000,
  });
}
